import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import CodaLineTable from '@accounting/components/tables/coda-line-table/coda-line-table.vue';

@Component({
  name: 'bpc-coda-lines',
  components: {
    'bpc-coda-line-table': CodaLineTable,
  },
})
export default class CodaLines extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
